<div class="module-wrapper content-wrapper*">
  <div class="tab-container">

    <div class="filter-section" *ngIf="dataAvailable">
      <div class="btn-wrapper">
        <button mat-flat-button color="" class="btn-primary" (click)="openDialogPreview()"
          [disabled]="isNoQuestions">{{'itemDetails.TabQuestions.btnPreview' | translate}}</button>
        <button mat-flat-button color="" class="btn-warn" (click)='toggle(true)'
          [disabled]="isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)">
          <span>+ {{'itemDetails.TabQuestions.btnNew' | translate}}</span>
        </button>
      </div>
      <app-choose-question-type *ngIf="flag" class="rem"></app-choose-question-type>
    </div>

    <ng-template mat-tab-label>
      <span class="menu-icon">
        <i-feather name="help-circle"></i-feather>
      </span>
      <span>Questions ({{numberOfQuestions}})</span>
    </ng-template>

    <div *ngIf="!dataAvailable">
      <div *ngIf="!buttonWasClicked && !isEdit">
        <div class="filter-section">
          <div class="btn-wrapper" *ngIf="spinner">
            <button mat-flat-button color="" class="preview-btn btn-primary" (click)="openDialogPreview()"
              [disabled]="isNoQuestions">{{'itemDetails.TabQuestions.btnPreview' | translate}}</button>
            <button mat-flat-button color="" class="btn-warn" (click)='toggle(true)'
              [disabled]="isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)">
              <span>+ {{'itemDetails.TabQuestions.btnNew' | translate}}</span>
            </button>
          </div>
        </div>
        <div class="table-container item-details-table">
          <table mat-table [dataSource]="questions" class="mat-elevation-z8
            question-details" #table cdkDropList [cdkDropListData]="questions"
            (cdkDropListDropped)="dropTable($event)">

            <ng-container matColumnDef="itemBankName">
              <th *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row" class="cell-content">
                <div class="div-content"
                  *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.MultipleChoiceOptions &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.MultipleChoiceOptions) ||
                  (row?.questionTypeId == QuestionTypeIdEnum.multichoice_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_MultipleChoiceOptions)
                  || (row?.questionTypeId == QuestionTypeIdEnum.styleType_options && row?.questionSubtypeId == QuestionSubTypeIdEnum.style_MultipleChoiceOptions)">

                  <app-preview-multiple-choice-multiple-response [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions>
                  </app-preview-multiple-choice-multiple-response>
                </div>
                <div class="div-content"
                  *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.MultipleChoiceStandard &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.MultipleChoiceStandard) ||
                  (row?.questionTypeId == QuestionTypeIdEnum.multichoice_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_MultipleChoiceStandard)
                  || (row?.questionTypeId == QuestionTypeIdEnum.styleType_options && row?.questionSubtypeId == QuestionSubTypeIdEnum.style_MultipleChoiceStandard)">

                  <app-preview-multiple-choice-single-response *ngIf="ItemIdQue" [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions>
                  </app-preview-multiple-choice-single-response>
                </div>
                <div class="div-content"
                  *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.MultipleChoiceYesOrNo &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.MultipleChoiceYesOrNo) ||
                  (row?.questionTypeId == QuestionTypeIdEnum.multichoice_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_MultipleChoiceYesOrNo)
                  || (row?.questionTypeId == QuestionTypeIdEnum.styleType_options && row?.questionSubtypeId == QuestionSubTypeIdEnum.style_MultipleChoiceYesOrNo)">

                  <app-preview-multiple-choice-true-or-false [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions>
                  </app-preview-multiple-choice-true-or-false>
                </div>

                <div class="div-content"
                  *ngIf="(row?.questionTypeId == QuestionTypeIdEnum.Matrix &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.Matrix) ||
                  (row?.questionTypeId == QuestionTypeIdEnum.Matrix_score_option && row?.questionSubtypeId == QuestionSubTypeIdEnum.scoringType_Matrix)">
                  <app-preview-matrix-single-choice [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-matrix-single-choice>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.Descriptive &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.Descriptive">
                  <app-preview-descriptive-plain-text [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-descriptive-plain-text>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveySingleChoice &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveySingleChoice">
                  <app-preview-survey-single-choice [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-survey-single-choice>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyMultiResponse &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyMultiResponse">
                  <app-preview-survey-multi-response [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-survey-multi-response>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyShortAnswer &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyShortAnswer">
                  <app-preview-survey-short-answer [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-survey-short-answer>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyLikeDislike &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyLikeDislike">
                  <app-preview-survey-like-dislike [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-survey-like-dislike>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyStarRating &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyStarRating">
                  <app-preview-survey-star-rating [isReadOnly]='true' [questions]='row' [numberOfStarList]='row.options'
                    [displayMode]=row?.questiondisplayoptions></app-preview-survey-star-rating>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.SurveyNumberRating &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.SurveyNumberRating">
                  <app-preview-survey-number-rating [isReadOnly]='true' [questions]='row' [optionOfNumber]='row.options'
                    [displayMode]=row?.questiondisplayoptions></app-preview-survey-number-rating>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.FillInTheBlanks &&
                  row?.questionSubtypeId == QuestionSubTypeIdEnum.FillInTheBlanks">
                  <app-preview-fill-in-the-blank-text [isReadOnly]='true' [showAnswer]="true" [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-fill-in-the-blank-text>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.MatchOrder">
                  <app-preview-match-order-match-list [isReadOnly]='true' [questions]='row'
                    [displayMode]=row?.questiondisplayoptions></app-preview-match-order-match-list>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.Hotspot && row?.questionSubtypeId == QuestionSubTypeIdEnum.HotspotSingleChoice">
                  <app-preview-hotspot-question [questions]='row'></app-preview-hotspot-question>
                </div>
                <div class="div-content" *ngIf="row?.questionTypeId == QuestionTypeIdEnum.Hotspot && row?.questionSubtypeId == QuestionSubTypeIdEnum.HotspotMultiChoice">
                  <app-preview-hotspot-multi-choice [questions]='row'></app-preview-hotspot-multi-choice>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="itemDescription">
              <th *matHeaderCellDef class="icon-td"> </th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="editQuestion(element)" [ngClass]="{disableIcon: isPublished || (roleSer.accessData?!roleSer.accessData.updateAllowed || !roleSer.accessData.insertAllowed:true)}" matTooltip="{{'itemDetails.TabQuestions.itemTable.edit' | translate}}">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteQuestion(element)" [ngClass]="{disableIcon: isPublished || (roleSer.accessData?!roleSer.accessData.deleteAllowed :true)}" matTooltip="{{'itemDetails.TabQuestions.itemTable.delete' | translate}}">
                  <mat-icon>delete_outline</mat-icon>
                </button>

                <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editQuestion(element)"
                    [disabled]="isPublished || (roleSer.accessData?!roleSer.accessData.updateAllowed || !roleSer.accessData.insertAllowed:true)">
                    <mat-icon>edit</mat-icon>
                    <span>{{'itemDetails.TabQuestions.itemTable.edit' | translate}}</span>
                  </button>
                  <button mat-menu-item (click)="deleteQuestion(element)"
                    [disabled]="isPublished || (roleSer.accessData?!roleSer.accessData.deleteAllowed :true)">
                    <mat-icon>delete_outline</mat-icon>
                    <span>{{'itemDetails.TabQuestions.itemTable.delete' | translate}}</span>
                  </button>
                </mat-menu> -->
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></tr>
          </table>
        </div>
      </div>
      <app-choose-question-type *ngIf="flag"></app-choose-question-type>
      <app-items-descriptive-plain-text *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.Descriptive"
        (postCreated)="onPostAdded($event)"></app-items-descriptive-plain-text>
      <app-items-matrix-single-choice
        *ngIf="isEdit &&
      (questionSubtypeId === QuestionSubTypeIdEnum.Matrix || questionSubtypeId === QuestionSubTypeIdEnum.scoringType_Matrix)"
        (postCreated)="onPostAdded($event)">
      </app-items-matrix-single-choice>
      <app-items-survey-number-rating *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.SurveyNumberRating"
        (postCreated)="onPostAdded($event)"></app-items-survey-number-rating>
      <app-items-fill-in-the-blank-text *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.FillInTheBlanks"
        (postCreated)="onPostAdded($event)"></app-items-fill-in-the-blank-text>
      <app-items-survey-short-answer *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.SurveyShortAnswer"
        (postCreated)="onPostAdded($event)">
      </app-items-survey-short-answer>
      <app-items-multiple-choice-multiple-response *ngIf="isEdit &&
      (questionSubtypeId === QuestionSubTypeIdEnum.MultipleChoiceOptions || questionSubtypeId === QuestionSubTypeIdEnum.scoringType_MultipleChoiceOptions
      || questionSubtypeId === QuestionSubTypeIdEnum.style_MultipleChoiceOptions)" (postCreated)="onPostAdded($event)">
      </app-items-multiple-choice-multiple-response>
      <app-items-multiple-choice-true-or-false *ngIf="isEdit &&
      (questionSubtypeId==QuestionSubTypeIdEnum.MultipleChoiceYesOrNo || questionSubtypeId==QuestionSubTypeIdEnum.scoringType_MultipleChoiceYesOrNo
      || questionSubtypeId === QuestionSubTypeIdEnum.style_MultipleChoiceYesOrNo)" (postCreated)="onPostAdded($event)">
      </app-items-multiple-choice-true-or-false>
      <app-items-multiple-choice-single-response *ngIf="isEdit &&
      (questionSubtypeId==QuestionSubTypeIdEnum.MultipleChoiceStandard || questionSubtypeId==QuestionSubTypeIdEnum.scoringType_MultipleChoiceStandard
      || questionSubtypeId === QuestionSubTypeIdEnum.style_MultipleChoiceStandard)"
        (postCreated)="onPostAdded($event)">
      </app-items-multiple-choice-single-response>
      <app-items-survey-single-choice *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.SurveySingleChoice"
        (postCreated)="onPostAdded($event)">
      </app-items-survey-single-choice>
      <app-items-survey-multi-response *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.SurveyMultiResponse"
        (postCreated)="onPostAdded($event)">
      </app-items-survey-multi-response>
      <app-items-survey-like-dislike *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.SurveyLikeDislike"
        (postCreated)="onPostAdded($event)">
      </app-items-survey-like-dislike>
      <app-items-survey-star-rating *ngIf="isEdit && questionSubtypeId==QuestionSubTypeIdEnum.SurveyStarRating"
        (postCreated)="onPostAdded($event)">
      </app-items-survey-star-rating>
      <app-items-match-order-match-list *ngIf="isEdit &&
        questionTypeId === QuestionTypeIdEnum.MatchOrder"
        (postCreated)="onPostAdded($event)"></app-items-match-order-match-list>
      <app-items-hotspot-question *ngIf="isEdit && questionSubtypeId == QuestionSubTypeIdEnum.HotspotSingleChoice" (postCreated)="onPostAdded($event)"></app-items-hotspot-question>
      <app-items-hotspot-multi-choice *ngIf="isEdit && questionSubtypeId === QuestionSubTypeIdEnum.HotspotMultiChoice" (postCreated)="onPostAdded($event)"></app-items-hotspot-multi-choice>
    </div>
  </div>
  <div *ngIf="dataAvailable"> {{'itemDetails.TabQuestions.errorMsg' | translate}} </div>
</div>

<app-item-preview #itemPreview></app-item-preview>
